module.exports = "/_next/static/images/81653bfcf4216e01df560d6621433168-two-people-looking-md@3x.jpg";